import { Inject, Injectable } from "@angular/core";
import { tap, catchError, map, Observable } from "rxjs";
import { ApiResponse, PaginatedData } from "../domain/models/apiResponse";
import ErrorsHandler from "./errors-handler";
import IManageMessages from "./ports/i-manage-messages";
import IDisplayCards from "./ports/display/i-display-cards";
import { Card, CreateCardRequestDto, UpdateCardRequestDto } from "./models/card";
import IManageCards from "./ports/manage/i-manage-cards";

@Injectable()
export class CardsDisplayer implements IDisplayCards {
  cards: Card[] = [];

  constructor(
    private _errorHandler: ErrorsHandler,
    @Inject('IManageCards') private _cardsManager: IManageCards,
    @Inject('IManageMessages') private _messagesManager: IManageMessages
  ) {}

  getCardsList(pageIndex: number = 1, pageSize: number = 10): Observable<ApiResponse<PaginatedData<Card>>> {
    return this._cardsManager.getCards(pageIndex, pageSize).pipe(
      tap(_ => this._messagesManager.add("Fetched cards")),
      catchError(this._errorHandler.handleError<ApiResponse<PaginatedData<Card>>>('getCardsPaged')),
      map(response => {
        this.cards = response.data.data;
        return response;
      })
    );
  }

  getCardByModuleId(id: number): Observable<ApiResponse<Card[]>> {
    return this._cardsManager.getCardByModuleId(id).pipe(
      tap(_ => this._messagesManager.add(`Fetched card with id ${id}`)),
      catchError(this._errorHandler.handleError<ApiResponse<Card[]>>('getCardByModuleId'))
    );
  }

  existsNameCard(name: string): Observable<ApiResponse<boolean>> {
    return this._cardsManager.existsNameCard(name).pipe(
      tap(_ => this._messagesManager.add(`Fetched card with name ${name}`)),
      catchError(this._errorHandler.handleError<ApiResponse<boolean>>('existsNameCard')),
      map(response => response)
    );
  }
}

